import { split } from "apollo-link";
import { getMainDefinition } from "@apollo/client/utilities";
import { createCustomHttpLink } from "./httpLink";
import { createCustomActionCableLink } from "./actionCableLink";

// split based on operation type
const splitterFunction = ({ query }) => {
  const definition = getMainDefinition(query);

  return (
    definition.kind === "OperationDefinition" &&
    definition.operation === "subscription"
  );
};

const customLink = split(
  splitterFunction,
  createCustomActionCableLink(),
  createCustomHttpLink()
);

export { customLink };
